import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { sentimentType } from '@op/utils';
import { getSentimentValue } from '@op/pages/community/hashtag/utils';
import { sentimentIcon } from '@/pages/opinion/constants';
import './index.scss';
export default function Sentiment({
  sentiment,
  showValue = true,
  className,
  iconClassName,
}: {
  sentiment: number;
  showValue?: boolean;
  className?: string;
  iconClassName?: string;
}) {
  const index = sentimentType(sentiment, true) as number;

  return (
    <div className={`sentiment-wrapper ${className}`}>
      <SvgIcon
        className={`editbox-item-icon ${iconClassName}`}
        type={sentimentIcon[index]}
      />
      {showValue ? (
        <span className="sentiment-value">{getSentimentValue(sentiment)}</span>
      ) : null}
    </div>
  );
}
